<template>
  <!-- 赠险订单 -->
  <div class="insuredOrder main-container">
    <div class="content">
      <div class="search-box btn3" :class="{ 'close': !searchMore }">
        <div class="input-item">
          <span class="label">保险公司</span>
          <Select v-model="searchParams.companyCode" :transfer="true" filterable clearable>
            <Option v-for="(item, i) in companyList" :key="i" :value="item.code">{{ item.name }}</Option>
          </Select>
        </div>
        <div class="input-item">
          <span class="label">创建时间</span>
          <DatePicker
            type="daterange"
            split-panels
            separator="至"
            :transfer="true"
            placement="bottom"
            format="yyyy-MM-dd"
            placeholder="选择日期"
            :value="searchParams.date"
            @on-change="searchParams.date = $event"
          ></DatePicker>
        </div>
        <div class="input-item">
          <span class="label">订单号</span>
          <Input v-model="searchParams.orderNo" placeholder="请输入" clearable />
        </div>
        <div class="input-item">
          <span class="label">投保单号</span>
          <Input v-model="searchParams.proposalNo" placeholder="请输入" clearable />
        </div>
        <div class="input-item">
          <span class="label">订单状态</span>
          <Select v-model="searchParams.status" :transfer="true" clearable>
            <Option value="1">未支付</Option>
            <Option value="2">已付款</Option>
            <Option value="3">已退款</Option>
            <Option value="4">已失效</Option>
          </Select>
        </div>
        <div class="input-item">
          <span class="label">产品名称</span>
          <Input v-model="searchParams.productName" placeholder="请输入" clearable />
        </div>
        <div class="input-item select-two">
          <Select v-model="searchParams.userType" :transfer="true">
            <Option value="1">投保人</Option>
            <Option value="2">被保险人</Option>
          </Select>
          <Input v-model="searchParams.name" placeholder="姓名/手机号" clearable />
        </div>
        <div class="btn-item">
          <Button type="primary" @click="searchAjax()">搜索</Button>
          <Button type="primary" ghost @click="resetSearch()">重置</Button>
          <Button type="primary" ghost v-if="searchMore" @click="searchMore = false"
            >收起
            <Icon type="ios-arrow-up" />
          </Button>
          <Button type="primary" ghost v-else @click="searchMore = true"
            >展开
            <Icon type="ios-arrow-down" />
          </Button>
        </div>
      </div>
      <div class="tab-box">
        <Tabs v-model="searchParams.firstTab" v-if="userInfo.userType != 4 && userInfo.isSubData" :animated="false" @on-click="toggleFirstTab">
          <TabPane label="全部订单" name="1"></TabPane>
          <TabPane label="直属团队订单" name="2"></TabPane>
          <TabPane label="下级机构订单" name="3"></TabPane>
        </Tabs>
        <div class="tools-box">
          <Button type="primary" ghost @click="exportList">导出</Button>
        </div>
      </div>
      <div class="table-box setTable">
        <loading :isShow="$root.$children[0].isShowLoading" />
        <Table :columns="columns" :data="tableDate">
          <template slot-scope="{ row }" slot="bar">
            <span @click="$refs.orderDetailModal.open(row)" class="table-btn">详情</span>
            <!-- <Tooltip content="有关联保单的订单不允许删除" style="display: inline-block" v-if="row.policyNo" transfer>
              <span class="table-btn gray">删除</span>
            </Tooltip> -->
            <!-- <span @click="del(row)" class="table-btn red" v-else>删除</span> -->
          </template>
        </Table>
      </div>
      <div class="pageBox">
        <Page :total="total" :current="searchParams.pageNo" :page-size="searchParams.pageSize" show-total @on-change="pageChange" style="text-align: center" />
      </div>
    </div>

    <!-- 订单详情 -->
    <order-detail-Modal ref="orderDetailModal"></order-detail-Modal>
    <!-- 确认弹窗 -->
    <confirm-Modal ref="confirmModal"></confirm-Modal>
  </div>
</template>

<script>
import confirmModal from '@/components/commons/confirmModal';
import orderDetailModal from '@/pages/orderManage/order/components/orderDetailModal'
import { mapState } from 'vuex';
import _ from 'lodash';
import { pageTool } from '@/api/mixins';
import selectTree from '@/components/system/selectTree3';
import { config } from './index.config.js';
export default {
  mixins: [pageTool, config],
  components: {
    confirmModal,
    selectTree,
    orderDetailModal
  },
  data() {
    return {
      isShowTxt: false,
      cur: 0,
      curActive: 0,
      total: 0,
      //过滤项
      searchParams: {
        queryGift: '1',
        userType: '1',
        pageNo: 1,
        pageSize: 10
      },
      sendTabbase: [
        {
          label: '全部',
          value: '1'
        },
        {
          label: '待支付',
          value: '6'
        },
        {
          label: '人工核保中',
          value: '2'
        },
        {
          label: '核保失败',
          value: '3'
        },
        {
          label: '已撤单',
          value: '4'
        },
        {
          label: '待核保',
          value: '0'
        },
        {
          label: '预核保成功',
          value: '10'
        },
        {
          label: '预核保失败',
          value: '-3'
        }
      ],
      firstTab: '1', //一级tab
      showOrderdetail: false,
      fold: true,
      //表单搜索字段
      columns: [],
      tableDate: [],
      companyList: [],
      supplierList: []
    };
  },
  computed: {
    ...mapState(['userInfo']),
  },
  mounted() {
    this.searchParamsOrigin = JSON.parse(JSON.stringify(this.searchParams));
    this.getCompanyList();
  },
  activated() {
    this.getOrder();
  },
  methods: {
    del(item) {
      this.$refs.confirmModal
        .open({
          title: '提示',
          content: '确定删除订单？'
        })
        .then(() => {
          this.$http({
            url: '/buz/order/order/del',
            type: 'GET',
            data: {
              id: item.id
            }
          }).then(res => {
            this.$notice.msg('删除订单成功');
            this.getOrder();
          });
        });
    },
    // 获取保司列表
    getCompanyList() {
      this.$http({
        url: `/buz/insuranceCompany/read/list`,
        type: 'POST',
        data: { companyType: '1' }
      }).then(res => {
        this.companyList = res.data;
      });
    },
    async exportList() {
      const params = this.initFilterObj();
      const res = await this.$http({
        type: 'POST',
        forced: true,
        responseType: 'blob',
        All: true,
        url: `/buz/order/export`,
        data: params,
        apiPermissionCode: 'order_10_2'
      });
      const fileName = decodeURI(res.headers['content-disposition'].split(';')[1].split('filename=')[1]);
      const blob = new Blob([res.data]); //构造一个blob对象来处理数据
      // const fileName = "xx.xls";
      //对于<a>标签，只有 Firefox 和 Chrome（内核） 支持 download 属性
      //IE10以上支持blob但是依然不支持download
      if ('download' in document.createElement('a')) {
        //支持a标签download的浏览器
        const link = document.createElement('a'); //创建a标签
        link.download = fileName; //a标签添加属性
        link.style.display = 'none';
        link.href = URL.createObjectURL(blob);
        document.body.appendChild(link);
        link.click(); //执行下载
        URL.revokeObjectURL(link.href); //释放url
        document.body.removeChild(link); //释放标签
      } else {
        //其他浏览器
        navigator.msSaveBlob(blob, fileName);
      }
      this.$Message.success('导出成功');
    },
    //切换一级tab
    async toggleFirstTab() {
      if (this.searchParams.firstTab === this.copyFirstTab) return;
      this.curActive = 0;
      this.searchParams.secondTab = '1'; //复位二级tab
      this.searchParams.pageNo = 1;
      this.getOrder();
    },
    pageChange(pageNo) {
      this.searchParams.pageNo = pageNo;
      this.getOrder();
    },
    //搜索
    searchAjax() {
      this.searchParams.pageNo = 1;
      this.$root.$children[0].isShowLoading = true;
      this.getOrder();
    },
    //获取订单
    async getOrder() {
      const params = this.initFilterObj();
      this.copyFirstTab = params.firstTab; //备份
      this.copySecondTab = params.secondTab;
      this.$root.$children[0].isShowLoading = true;
      this.$http({
        url: '/buz/order/read/list',
        type: 'POST',
        data: params,
        apiPermissionCode: 'order_90_1_0'
      })
        .then(res => {
          this.tableDate = res.data;
          this.total = res.total;
          this.$root.$children[0].isShowLoading = false;
        })
        .catch(() => {
          this.$root.$children[0].isShowLoading = false;
        });
    },
    //获取最新搜索条件
    initFilterObj() {
      const params = JSON.parse(JSON.stringify(this.searchParams));
      if (params.date && params.date[0]) {
        //创建时间
        params.createTimeStart = params.date[0];
        params.createTimeEnd = params.date[1];
      }
      delete params.date;
      if (params.userType == 1) {
        //投保人
        params.holderName = params.name;
      } else if (params.userType == 2) {
        //被保险人
        params.insuranceName = params.name;
      }
      delete params.userType;
      delete params.name;

      delete params.applyOrgId;
      return params;
    }
  },
};
</script>
<style lang="scss" scoped>
/deep/ .formGroup:after {
  display: none;
}

/deep/ .ivu-form-item-content {
  color: #272933;
}

/deep/ .ivu-modal-body {
  padding: 16px 30px;
}

.my-modal /deep/ .formGroup {
  position: relative;
  padding: 0;

  &:after {
    position: absolute;
    bottom: -5px;
    width: 100%;
    height: 20px;
    content: '';
    filter: blur(5px);
    background: #fff;
  }
}

.my-modal /deep/ .title {
  width: 100%;
  padding-bottom: 10px;
  padding-top: 10px;
  font-size: 14px;
  color: #3c464f;
  font-weight: bold;
  position: relative;
  display: flex;
  align-items: center;
  white-space: nowrap;
  height: 40px;

  &::before {
    content: '';
    display: block;
    width: 3px;
    height: 12px;
    background-color: #236dff;
    margin-right: 6px;
  }

  &::after {
    content: '';
    display: block;
    background-color: #eff3fc;
    height: 1px;
    width: 100%;
    margin-left: 10px;
  }
}

@import './index.scss';

.myFormStyle /deep/ .selectStyle .ivu-select-selection {
  background-color: #f8f8f9;
}
</style>
